module.exports = __webpack_public_path__ + "img/doctor-consulting.ed9cd805.svg";